import { inject } from 'tsyringe'
import { containerScoped } from '~/decorators/dependency-container'
import RequestBuilder from '~/builders/http/RequestBuilder'
import {
  AuditsAvailableProvidersResult,
  AvailableForAuditsCounts,
  AvailableAuditProviderLogo
} from '~/models/audit/available'

@containerScoped()
export default class AuditsClassifiedsService {
  constructor(@inject(RequestBuilder) private requestBuilder: RequestBuilder) {}

  public getAvailableAuditsOptionsForClassified(
    classifiedId: number | string
  ): Promise<AuditsAvailableProvidersResult> {
    return this.requestBuilder
      .request('get', `/api/audits/classified/${classifiedId}/available/`)
      .validate(body => body?.data?.audit_providers)
      .send()
  }

  public getAvailableForAuditsCounts(): Promise<AvailableForAuditsCounts> {
    return this.requestBuilder
      .request('get', '/api/audits/classifieds/available-for-audit-counts/')
      .send()
  }

  public getAvailableAuditProvidersLogos(): Promise<
    AvailableAuditProviderLogo[]
  > {
    return this.requestBuilder
      .request('get', '/api/audits/audit-providers/logos/')
      .send()
  }
}
